import * as THREE from 'three';

// ── Hero camera positions (hardwired) ─────────────────────────────────────────────
export interface HeroPosition { id: string; name: string; position: { x: number; y: number; z: number }; color: string; fov: number; }

// TODO: replace these test positions with the real hero angles.
export const HERO_POSITIONS: HeroPosition[] = [
  { id: 'hero-xolivestream', name: 'XO Live Stream', position: { x: 3.747, y: 0.045, z: 3.709 }, color: '#000000', fov: 30 },
  { id: 'hero-styleframe', name: 'Styleframe', position: { x: 3.1, y: 0.189, z: 0.298 }, color: '#000000', fov: 72 },
  { id: 'hero-footbridge', name: 'Footbridge', position: { x: -6.358, y: -0.314, z: -5.412 }, color: '#000000', fov: 30 },
  { id: 'hero-golfcourse', name: 'Golf Course', position: { x: 7.240, y: -0.102, z: -2.349 }, color: '#000000', fov: 30 },
  { id: 'hero-hh', name: 'Howard Hughes', position: { x: 3.431, y: -0.188, z: 1.391 }, color: '#000000', fov: 30 },
  { id: 'hero-hotel-view', name: 'Venetian/Wynn', position: { x: -5.210, y: 1.248, z: -5.665 }, color: '#000000', fov: 30 },
  { id: 'hero-on-site-1', name: 'On Site 1 (NW)', position: { x: -1.134, y: -0.378, z: -1.288 }, color: '#000000', fov: 30 },
  { id: 'hero-on-site-2', name: 'On Site 2 (SE)', position: { x: 2.224, y: -0.381, z: 0.990 }, color: '#000000', fov: 30 },
  { id: 'hero-north', name: 'North', position: { x: 0.000, y: 0.557, z: -5.384 }, color: '#000000', fov: 30 },
  { id: 'hero-south', name: 'South', position: { x: 0.000, y: 0.557, z: 5.384 }, color: '#000000', fov: 30 },
  { id: 'hero-east', name: 'East', position: { x: 5.384, y: 0.557, z: 0.000 }, color: '#000000', fov: 30 },
  { id: 'hero-west', name: 'West', position: { x: -5.384, y: 0.557, z: 0.000 }, color: '#000000', fov: 30 },
  { id: 'hero-top', name: 'Top', position: { x: 0.000, y: 5.509, z: 0.000 }, color: '#000000', fov: 30 },
];

/** Angular distance at which hero background fade begins (fade out fully at this angle). */
export const HERO_FADE_RAD = THREE.MathUtils.degToRad(15);
/** Angular distance at which soft-snap triggers. */
export const HERO_SNAP_RAD = THREE.MathUtils.degToRad(5);

/** Returns the nearest hero within HERO_FADE_RAD and the 0–1 blend alpha for its background. */
export function computeHeroFade(camPosVec: THREE.Vector3): { hero: HeroPosition | null; alpha: number } {
  const camNorm = camPosVec.clone().normalize();
  let best: HeroPosition | null = null;
  let bestAngle = Infinity;
  for (const h of HERO_POSITIONS) {
    const hDir = new THREE.Vector3(h.position.x, h.position.y, h.position.z).normalize();
    const angle = Math.acos(Math.max(-1, Math.min(1, camNorm.dot(hDir))));
    if (angle < HERO_FADE_RAD && angle < bestAngle) { bestAngle = angle; best = h; }
  }
  if (!best) return { hero: null, alpha: 0 };
  return { hero: best, alpha: 1 - bestAngle / HERO_FADE_RAD };
}
